import { useState } from 'react';
import axios from 'axios';
import { Ban } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Replaces the order button when a product is sold out. Tap = "restocked soon" + dispatcher alert.
export const SoldOutButton = ({ product, modern = false, compact = false, testId }) => {
  const [busy, setBusy] = useState(false);
  const tap = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/products/${product.id}/sold-out-tap`, {}, { withCredentials: true });
      toast.info(data?.message || 'This product will be restocked soon.');
    } catch {
      toast.info('This product will be restocked soon.');
    } finally {
      setBusy(false);
    }
  };
  if (modern) {
    return (
      <button type="button" onClick={tap} disabled={busy} data-testid={testId}
        className="am-tnum"
        style={{
          flex: compact ? undefined : 1, padding: compact ? '6px 12px' : '14px 20px', fontSize: compact ? 12 : 14,
          fontWeight: 600, borderRadius: 999, border: '1px solid var(--am-hair-strong)', cursor: 'pointer',
          background: 'var(--am-surface-2, #F1EFE9)', color: 'var(--am-ink-2)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
        }}>
        {!compact && <Ban size={15} />}Sold out
      </button>
    );
  }
  return (
    <button type="button" onClick={tap} disabled={busy} data-testid={testId}
      className="w-full border border-[#FF3B30] text-[#FF3B30] bg-[#050003] hover:bg-[#FF3B30]/10 font-mono font-bold uppercase tracking-wider px-4 py-2 flex items-center justify-center gap-2 transition-colors">
      <Ban className="w-4 h-4" /> SOLD OUT
    </button>
  );
};
